import envVar from '../../config/envVars';
import authenticationUtils from '../../utils/authenticationUtils';
import httpClient from '../httpClient';
import { ImportedTransactionStatusReportResponse } from '../../types/transactionStatusType';

const uploadTransactionStatusReport = async (
  file: File,
  onProgress: (percent: number) => void
): Promise<ImportedTransactionStatusReportResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  const url = `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/transactions/import`;
  const response: any = await httpClient.put(url, formData, {
    headers: {
      Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
    },
    onUploadProgress: (e) => {
      const percent = Math.round((e.loaded * 100) / (e.total ?? 1));
      onProgress(percent);
    }
  });
  return response as ImportedTransactionStatusReportResponse;
};

const transactionStatusReportApis = {
  uploadTransactionStatusReport
};

export default transactionStatusReportApis;
